<template>
    <li>
        <div class="item__header d-flex">
            <span class="title">{{item.order}}. {{ item.name }}</span>
            <div class="d-flex options ms-auto">
                <i class="far fa-edit" @click="$emit('onEdit', item)"></i>
                <i
                    class="far"
                    :class="{ 'fa-eye-slash': !item.status, 'fa-eye': item.status }"
                    @click="$emit('onToggle', item)"
                ></i>
                <i class="far fa-trash" @click="$emit('onRemove', item)"></i>
            </div>
        </div>
        <ul v-if="item.childrens && item.childrens.length">
            <SubItem
                v-for="(child, i) in item.childrens"
                :key="i"
                :item="child"
                @onEdit="(item) => $emit('onEdit', item)"
                @onToggle="(item) => $emit('onToggle', item)"
                @onRemove="(item) => $emit('onRemove', item)"
            ></SubItem>
        </ul>
    </li>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
    props: { item: Object },
});
</script>

<style scoped>
.item__header {
    padding-block: 5px;
}
li {
    padding-left: 1rem;
    border-bottom: 1px solid var(--border-shadow);
}
li:first-child {
    border-top: 1px solid var(--border-shadow);
}
li:last-child {
    border-bottom: none;
}

ul.childrens {
    border-top: 1px solid var(--border-shadow);
}

.options {
    column-gap: 8px;
    align-items: center;
}
.options i {
    cursor: pointer;
}

.fa-eye-slash {
    font-size: 0.9em;
}
</style>
